<script>
import {turpial} from './libraries/turpial'

export let version = "tpi-1.7.8" // e.g: tpi-1.7.2

turpial.linkCSS({
	url: [
		`https://cdn.jsdelivr.net/gh/Yerikmiller/3pod-us.github.io@${version}/icons/platform/tripod-pack/tripod-pack.css?v1`,
		`https://cdn.jsdelivr.net/gh/Yerikmiller/3pod-us.github.io@x-outline-1.0.1/icons/iconsax/vuesax-bold/IconFont.css`,
		`https://cdn.jsdelivr.net/gh/Yerikmiller/3pod-us.github.io@x-outline-1.0.1/icons/iconsax/vuesax-outline/IconFont.css`
	], ready: ()=>{}
})
</script>